import { mutatorAction } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import { getMailboxFolderTreeData } from '../selectors/getMailboxFolderTreeDataTable';
import { setFolderTreeData } from '../mutators/setFolderTreeData';
import type { MailFolder } from 'owa-graph-schema';
import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';

export const setSharedFolderArchiveInformationMutator: (
    sharedFolderUserEmail: string,
    mailboxInfo: MailboxInfo,
    archiveMailboxInfo: MailboxInfo,
    archiveFolder: MailFolder
) => void = mutatorAction(
    'setSharedFolderArchiveInformation',
    (
        sharedFolderUserEmail: string,
        mailboxInfo: MailboxInfo,
        archiveMailboxInfo: MailboxInfo,
        archiveFolder: MailFolder
    ): void => {
        const mailboxFolderTreeDataTable = getMailboxFolderTreeData(mailboxInfo);
        if (mailboxFolderTreeDataTable) {
            mailboxFolderTreeDataTable.sharedArchiveInformation.set(
                sharedFolderUserEmail,
                archiveMailboxInfo
            );
        }

        // update the archive folder tree root and loading state.
        setFolderTreeData(
            archiveMailboxInfo.mailboxSmtpAddress,
            archiveFolder,
            FolderTreeLoadStateEnum.Uninitialized,
            false,
            0,
            mailboxInfo,
            undefined
        );
    }
);
